import React from "react";
import cn from "classnames";
import styles from "./WhyPostaway.module.sass";
import InfoPage from ".";

const WhyPostaway = () => {
  const below = (
    <div className={styles.layoutContainer}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        {/* Why Postaway Title */}
        <h2 className={styles.pageTitle}>Why Postaway</h2>
        
        {/* Creators Card */}
        <div className={cn(styles.card, styles.cardCreators)}>
          <h3 className={styles.cardTitle}>CREATORS</h3>
          <div className={styles.cardContent}>
            <p style={{color: 'white'}}>• Gain access to unique stays and paid opportunities • Pitch collaborations on the collab board • Connect with other creators and hosts • Maintain full creative freedom while expanding your network and increasing visibility • Showcase group trips and itineraries • Earn bonuses by referring creators and hosts</p>
          </div>
        </div>

        {/* Hosts Card */}
        <div className={cn(styles.card, styles.cardHosts)}>
          <h3 className={styles.cardTitle}>HOSTS</h3>
          <div className={styles.cardContent}>
            <p style={{color: 'white'}}>• Gain access to top travel influencers, creators, and photographers open to collaborations • Pitch collaborations on the collab board • Connect with others in the travel space • Increase visibility and grow your account/business/bookings • Earn bonuses by referring creators and hosts • Showcase direct booking site</p>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className={styles.rightColumn}>
        {/* Travelers Card */}
        <div className={cn(styles.card, styles.cardTravelers)}>
          <h3 className={styles.cardTitle}>TRAVELERS</h3>
          <div className={styles.cardContent}>
            <p>• Gain access to top travel creators to search for itineraries and group trips • Gain access to unique stays and destinations • Book directly with Hosts to save money</p>
          </div>
        </div>

        {/* Travelers Image */}
        <div className={styles.travelersImage}>
          <img
            src="/Why.png"
            alt="Travelers"
          />
        </div>

        {/* Travelers Image Caption */}
        <div style={{
          fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
          fontSize: 'clamp(10px, 3vw, 12px)',
          color: '#0f084b',
          opacity: .9,
          lineHeight: 1.35,
          textAlign: 'center',
          marginTop: -25
        }}>
          @chelsea_schillizi x @thewanderingbuffalo
        </div>
      </div>
    </div>
  );

  return <InfoPage below={below} divider tallOverride={false} />;
};

export default WhyPostaway;